import { createFileRoute } from '@tanstack/react-router'

import { validateListSearch } from '#/shared/lib/list-search'

import { MessagingPricesPage } from '#/modules/pricing/messaging-prices-page'

export const Route = createFileRoute('/_shell/messaging-prices/')({
  component: MessagingPricesPage,
  validateSearch: validateListSearch,
})
